<script>
	import {user, fetch_data, view} from "../client.svelte.js";
  import {bonusToString, perksToString, protoActions, protoWeapons} from "../core.js";
	import Select from "../elements/Select.svelte";

	const equipSlots = {
		mainhand: "Haupthand",  missile: "Geschoß", sidehand: "Nebenhand", corearmor: "Rüstung",
		back: "Rücken", baldric: "Schultergehänge", belt_1: "Waffengurt rechts", belt_2: "Waffengurt links", sleeve: "Ärmel", boot: "Stiefel",
		head: "Kopf", shoulders: "Schultern", torso: "Rumpf", arms: "Arme", legs: "Beine", hands: "Hände", feet: "Füße", waist: "Hüfte",
		neck: "Hals", ears: "Ohren", wrist: "Handgelenk", finger_1: "Finger re", finger_2: "Finger li",}
	const slotOrder = ['mainhand', 'sidehand', 'corearmor', 'missile', 'head', 'shoulders', 'torso', 'arms', 'hands', 'waist', 'legs', 'feet', 'neck', 'ears', 'wrists', 'finger_1', 'finger_2']
	const capabilsOrder = ['cmb', 'off', 'def', 'rng', 'vital', 'mob', 'qic', 'acc', 'hvy', 'stf', 'cau', 'mag', 'focus']

	let outfits = $derived(
		user.equipments.values()
			.filter(equip => equip.CHAR === view.persona?.ID)
			.map(equip => Object.assign({ID: equip.ID, name: equip.OUTFIT}))
			.toArray()
	)

	let equipment = $derived(user.equipments.get(view.persona.equipment) ?? {})
	let equipped = $derived(
		Object.entries(equipment)
			.filter(([slot,item]) => slot in equipSlots && item)
			.map(([slot,itemID]) => [slot, user.gearitems.get(itemID) ?? {name: itemID}])
			.sort(([slotA, itemA],[slotB, itemB]) => slotOrder.indexOf(slotA) - slotOrder.indexOf(slotB))
	)

	let weapons = $derived(
	  (view.persona.weapons ?? [])
			.map(itemID => user.gearitems.get(itemID) ?? protoWeapons[itemID])
			.filter(item => item && item.ZUB === 'Weapon') )

	let capabils = $state([])

	// $inspect(`CAPABILS – equipment`, equipment)

  async function init() {
    const prowess = await fetch_data('/prowess', {actor: view.persona.ID})
    capabils = capabilsOrder.map(profID => Object.assign({}, prowess[profID], {ID: profID}))
	}

  $effect(() => {
    init()
  })

    function swap_weapon(e) {
        e.preventDefault()
        const coord = {x: e.clientX, y: e.clientY}
        const selRow = e.target.closest("tr")
        if (selRow && game.orders_possible) {
            // console.log(`GEAR: Show menu to swap weapon ${selRow.id} at `, coord)
            selRow.style.backgroundColor = "darkred"
		        const weapOptions = view.persona.options
			        .map(optID => protoActions[optID])
			        .filter(opt => opt?.aiming?.repr === 'weap')
			        .map(opt => Object.assign({}, {action: opt.ID, aim: selRow.id, execution: opt.execution, exertion: opt.exertion, kind: opt.kind}))
		        console.log(weapOptions)
            view.show_dialog('options', {coord: coord, options: {Waffen: weapOptions}})
        }
		}

		function change_outfit(e) {

		}
</script>


<!------------------------------- HTML ------------------------------------->

<div id="gearPanel" data-help="equip">
	{#if Object.keys(view.character.equipments ?? {}).length > 1}
		<div class="outfits">
			<Select field=outfit bind:value={view.persona.equipment} options={outfits} separate onchange={change_outfit}/>
		</div>
	{/if}
	<h3>Ausgerüstet</h3>
	<div id="equipped">
		<table>
			<thead>
				<tr>
					<th>Ort</th>
					<th>Gegenstand</th>
					<th>Besonderh.</th>
				</tr>
			</thead>
			<tbody>
				{#each equipped as [slot,item]}
					<tr>
						<td>{equipSlots[slot]}</td>
						<td>{item.name ?? "–"}</td>
						<td title={item.specials}>{perksToString(item.perks)}</td>
					</tr>
				{/each}
			</tbody>
		</table>
	</div>

	<h3>Waffen</h3>
	<div id=weaponsContainer>
    <table>
      <thead>
        <tr>
          <th>Waffe</th>
          <th>AD</th>
          <th>OG</th>
          <th>DG</th>
          <th>BS</th>
          <th>Pa</th>
        </tr>
      </thead>
      <tbody>
        {#each weapons as weap}
          <tr id={weap.ID}>
            <td>{weap.name}</td>
            <td>{weap.period}</td>
            <td>{bonusToString(weap.offmod)}</td>
            <td>{bonusToString(weap.defmod)}</td>
            <td>{weap.impact}</td>
            <td>{weap.fumble}</td>
          </tr>
        {/each}
      </tbody>
    </table>
	</div>

	<h3>Kampfwerte</h3>
	<table>
		<thead>
			<tr>
				<th>Kampfwert</th>
				<th>Krz</th>
				<th>Fert</th>
				<th>Waf</th>
				<th>Eff</th>
				<th>Ges</th>
			</tr>
		</thead>
		<tbody>
			{#each capabils as cap}
				<tr id={cap.name}>
					<td>{cap.name}</td>
					<td>{cap.ID}</td>
					<td>{cap.learned + cap.bonus}</td>
					<td>{cap.gear}</td>
					<td>{cap.temp}</td>
					<td>{cap.total}</td>
				</tr>
			{/each}
		</tbody>
	</table>
	<p>Waffenbonus wird erst später einberechnet</p>
</div>


<!------------------------------- STYLE ------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	#gearPanel
		padding: 5px
		background-color: colors.$grey-50

		tr:nth-child(even) td
			background-color: colors.$grey-15

		tr:nth-child(odd) td
			background-color: colors.$grey-20

		thead
			background-color: colors.$primary-060-black
			font-style: italic

		table, th, td
			border: none
			outline: none
			border-collapse: collapse

		td
			padding: 5px 5px

		h3
			background-color: colors.$primary-040-black
			padding: 5px 0
			margin-bottom: 0
			text-align: center
			border-radius: 15px 15px 0 0

	.outfits
		padding: 8px
		display: grid
		grid-template-columns: 2fr 1fr
		color: black
		font-weight: bold

</style>